// extracted by mini-css-extract-plugin
export var arrow = "bC_dh";
export var profile = "bC_fh";
export var text = "bC_fg";